import { styled } from "@mui/material/styles";
import { useIntl } from "react-intl";

import { getHelpCenterLang, helpCenterUrl } from "@/shared/services/helpCenter";

const FARM_CREATION_HELP_URL = helpCenterUrl(
  "cs",
  "/articles/572895-jak-vytvorim-svoji-farmu",
);

type Props = {
  copy: string;
  linkCopy: string;
};

const ImportHelp = ({ copy, linkCopy }: Props): React.JSX.Element | null => {
  const intl = useIntl();

  if (getHelpCenterLang(intl.locale) !== "cs") {
    return null;
  }

  const copyWithSeparator = `${copy}: `;

  return (
    <div>
      <Copy>
        {copyWithSeparator}
        <HelpLink
          data-testid="import-help-link"
          href={FARM_CREATION_HELP_URL}
          rel="noopener noreferrer"
          target="_blank"
        >
          {linkCopy}
        </HelpLink>
      </Copy>
    </div>
  );
};

const Copy = styled("p")(({ theme }) => ({
  ...theme.typography.caption,
  color: theme.palette.cf.cfDarkerGrey,
  margin: 0,
}));

const HelpLink = styled("a")(({ theme }) => ({
  color: theme.palette.cf.cfPrimary,
}));

export { ImportHelp };
